import Vue from 'vue'
//引入vuex
import Vuex from 'vuex'
//vuex持久化
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    corpId: '', //学校ID
    menuId: '', //打开菜单的ID
    selectedActivity:{},//当前选中社团活动
  },
  mutations: {
    setCorpId(state,corpId) {
      state.corpId = corpId
    },
    setMenuId(state,menuId) {
      state.menuId = menuId
    },
    setSelectedActivity(state,selectedActivity){
      state.selectedActivity = selectedActivity;
    }
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js